import React from 'react';
import TagStationModal from '../../../shared/component/tag/TagStationModal';
import { getAlertMessage } from '../../../shared/constants/alertMessages';
import { TagData } from '../../../shared/dto/EntityRepository';
import { useAdminVenueTag } from '../../share/hook/useAdminVenueTag';

interface VenueTagStationModalProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

const getDeleteConfirmMessage = (tag: TagData) =>
  getAlertMessage('CONFIRM_DELETE_VENUE_TAG', { name: tag.name });

const VenueTagStationModal: React.FC<VenueTagStationModalProps> = ({
  setIsUserInput,
}) => {
  const {
    tags,
    getVenueTagList,
    updateVenueTag,
    deleteVenueTag,
  } = useAdminVenueTag();

  return (
    <TagStationModal
      tags={tags}
      loadTags={getVenueTagList}
      loadKey="venue-tags"
      updateTag={updateVenueTag}
      deleteTag={deleteVenueTag}
      getDeleteConfirmMessage={getDeleteConfirmMessage}
      setIsUserInput={setIsUserInput}
    />
  );
};

export default VenueTagStationModal;
